import * as React from 'react';

function SvgCutIcon(props) {
  return (
    <svg
      data-name="Cut Icon"
      id="cut_icon__1"
      width={props.size || 23.56}
      height={props.size || 20.935}
      viewBox="0 0 23.56 20.935"
      xmlSpace="preserve"
      {...props}
    >
      <path
        data-name="Path 452"
        d="M23.56 3.624a3.469 3.469 0 00-4.808-.876l-8 5.6-2.903-2.037A4.2 4.2 0 106.08 7.975l3.56 2.493-3.56 2.493a4.209 4.209 0 101.769 1.664l2.907-2.036 8 5.6a3.469 3.469 0 004.808-.876L13.79 10.47zM4.216 6.397A2.181 2.181 0 116.4 4.216a2.181 2.181 0 01-2.184 2.181zm0 12.5A2.181 2.181 0 116.4 16.72a2.181 2.181 0 01-2.184 2.18z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgCutIcon;
